<div id="cart_side" class="add_to_cart" [ngClass]="direction" [class.openSide]="productService?.OpenCart">
    <a href="javascript:void(0)" class="overlay" (click)="closeCart()"></a>
    <div class="cart-inner">
        <div class="cart_top">
            <h3>my cart</h3>
            <div class="close-cart" (click)="closeCart()">
                <a href="javascript:void(0)">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </a>
            </div>
        </div>
        <div class="cart_media" *ngIf="products.length">
            <ul class="cart_product">
                <li *ngFor="let product of products">
                    <div class="media">
                        <a [routerLink]="['/shop/products', product.id]">
                            <img class="me-3" [src]="product.images[0].imageUrl" [alt]="product.images[0].id">
                        </a>
                        <div class="media-body">
                            <a [routerLink]="['/shop/products', product.id]">
                                <h4>{{ product?.name | titlecase }}</h4>
                            </a>
                            <h4>
                                <span>
                                    {{ product?.quantity }} x
                                    {{ product?.cost - (product?.cost * product?.discountPercent / 100) |
                                    currency:'VND' }}
                                </span>
                            </h4>
                        </div>
                    </div>
                    <div class="close-circle">
                        <a (click)="removeItem(product)">
                            <i class="ti-trash" aria-hidden="true"></i>
                        </a>
                    </div>
                </li>
            </ul>
            <ul class="cart_total">
                <li>
                    <div class="total">
                        <h5>
                            Tổng :
                            <span>{{ getTotal | async | currency:'VND' }}</span>
                        </h5>
                    </div>
                </li>
                <li>
                    <div class="buttons">
                        <a [routerLink]="['/shop/cart']" class="btn btn-solid btn-xs view-cart">Xem giỏ hàng</a>
                        <a (click)="checkout()" class="btn btn-solid btn-xs checkout">Thanh toán</a>
                    </div>
                </li>
            </ul>
        </div>
        <div class="col-sm-12 empty-cart-cls text-start" *ngIf="!products.length">
            <h4 class="mt-3">
                <strong>Giỏ hàng trống</strong>
            </h4>
            <a [routerLink]="['/home']" class="btn btn-solid">Tiếp tục mua sắm</a>
        </div>
    </div>
</div>
